// actions/similarProductsActions.js
import { FetchSimilarProducts } from "../../Services/MainServices";

export const fetchSimilarProducts = (pro_id) => async (dispatch) => {
  try {
    dispatch({ type: "SIMILAR_PRODUCTS_REQUEST" });

    const response = await FetchSimilarProducts(pro_id);
    // console.log("Response data:", response.data);

    dispatch({
      type: "SIMILAR_PRODUCTS_SUCCESS",
      payload: response.data.data, // ✅ This is an array of 20 items as shown in your console
    });
  } catch (error) {
    dispatch({
      type: "SIMILAR_PRODUCTS_FAILURE",
      payload: error.message || "Something went wrong",
    });
  }
};
